module.exports = __webpack_public_path__ + "static/media/header_rpm.69eea9fe.jpg";